import { FC } from 'react';
import { observer } from 'mobx-react';

import { Button, Flex, Menu, Text } from '@servicetitan/anvil2';
import moreVertIcon from '@servicetitan/anvil2/assets/icons/material/round/more_vert.svg';
import { useDependencies } from '@servicetitan/react-ioc';

import { TelecomBrandData } from '../api/telecom.api';
import { TcrStore } from '../stores/tcr.store';
import { StatusCard } from './status-card';
import { BrandDetailsCard } from './brand-details-card';
import { CampaignsCard } from './campaigns-card';

interface BrandSectionProps {
    brand: TelecomBrandData;
    brandIndex: number;
}

export const BrandSection: FC<BrandSectionProps> = observer(({ brand, brandIndex }) => {
    const [{ syncBrand, deleteBrand }] = useDependencies(TcrStore);
    return (
        <Flex direction="column" gap="6">
            {/* Brand Header */}
            <Flex direction="row" justifyContent="space-between" alignItems="center">
                <Text variant="headline" size="small" el="h2">
                    Brand {brandIndex}
                </Text>

                <Flex direction="row" gap="3" alignItems="center">
                    <Button
                        appearance="primary"
                        size="small"
                        onClick={() => syncBrand(brand.id, brand.ownerId)}
                    >
                        Sync Brand
                    </Button>

                    <Menu icon={moreVertIcon} size="small" aria-label="Brand actions">
                        <Menu.Item
                            label="Delete Brand"
                            onClick={() => deleteBrand(brand.id, brand.ownerId)}
                        />
                    </Menu>
                </Flex>
            </Flex>

            {/* Brand Information Cards */}
            <Flex direction="column" gap="6">
                <StatusCard brand={brand} />
                <BrandDetailsCard brand={brand} />
                <CampaignsCard brand={brand} />
            </Flex>
        </Flex>
    );
});
